import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function RepartitionIcon(props: IconProps) {
    return <Icon {...props} iconKey={"repartition"}/>
}
